import { userManagement_LABELS } from "../../../../constants/labels/UserManagement";
import { GridColumnDefs } from "../../../../models/Grid/gridColumnDefs";
import Grid from "../../../shared/Grid/Grid";
import Dropdown from "../../../shared/Dropdown/Dropdown";
import { useEffect, useMemo, useState } from "react";
import { UnassignUser } from "../../../shared/SVG/UnassignUser";
import { Button } from "@mui/material";
import "./ClinicUsers.scss";
import ConfirmationDialog from "../../../shared/ConfirmationDialog/ConfirmationDialog";

export function ClinicUsers(Props: any) {
  const [dropDownValue, setDropDownValue] = useState<any>("");
  const [unassignLicenceKey, setUnassignLicenceKey] = useState<any>(null);
  const rowData = useMemo(() => {
    return Props?.rowData;
  }, [Props.rowData]);
  const isBpSiteIdVerified = useMemo(() => {
    return Props.isBpSiteIdVerified;
  }, [Props.isBpSiteIdVerified]);
  const isSubscriptionActive = useMemo(() => {
    return Props.isSubscriptionActive;
  }, [Props.isSubscriptionActive]);

  const providersData = useMemo(() => {
    return Props?.providersData;
  }, [Props.providersData]);

  const RenderProvider = (props: any) => {
    return props?.data?.providerId ? (
      <>{props?.data?.providerName}</>
    ) : (
      <>
        <Dropdown
          menuItems={providersData}
          placeholder={"Providers"}
          name={"Provider"}
          selectedValue={dropDownValue}
          onChange={(value: any) => {
            setDropDownValue(value.value.providerId);
            Props?.assignLicence(props?.data?.licenseKey, value.value.gpUserId);
          }}
          onInputChange={(event: any, newInputValue: string) => {}}
          searchable
          dropdownSearchInputPlaceHolder={"Search"}
        />
      </>
    );
  };

  const RenderActions = (props: any) => {
    return props?.data?.providerId ? (
      <Button
        className={`provider-actions ${
          props?.data?.providerId ? "enable-action" : "disable-action"
        }`}
        onClick={() => {
          setUnassignLicenceKey(props?.data?.licenseKey);
        }}
      >
        <UnassignUser color={"#E47363"} />
        <span className="px-2">Unassign Provider</span>
      </Button>
    ) : (
      <></>
    );
  };
  const columnDefs: GridColumnDefs[] = [
    {
      headerName: userManagement_LABELS.licenceKey,
      field: "licenseKey",
    },
    {
      headerName: userManagement_LABELS.providerName,
      field: "providerName",
      cellRenderer: RenderProvider,
    },
    {
      headerName: userManagement_LABELS.providerId,
      field: "providerId",
    },
    {
      headerName: userManagement_LABELS.role,
      field: "role",
    },
    {
      headerName: userManagement_LABELS.actions,
      field: userManagement_LABELS.actions,
      cellRenderer: RenderActions,
    },
  ];
  return (
    <div className="clinic-users-wrapper">
      <div className="px-3 user-grid-header d-flex justify-content-between">
        <div>{userManagement_LABELS.userManagement}</div>
      </div>
      <div className="clinic-users-grid-wrapper">
        <Grid
          columnDefs={columnDefs}
          rowData={rowData}
          serverSidePagination
          rowCount={5}
          masterDetail
          searchFieldName=""
          withoutHeader={false}
          headerContent={userManagement_LABELS.userManagement}
          showTotalRowCount
          uniqueIdentifierFieldName={"id"}
          className="clinic-users-grid"
        ></Grid>
        <ConfirmationDialog
          open={unassignLicenceKey !== null}
          onConfirm={() => {
            Props?.unassignLicence(unassignLicenceKey);
            setUnassignLicenceKey(null);
          }}
          contentBody={
            <div>
              <div className="confirmation-header">Unassign a provider?</div>
              <div className="pt-3 confirmation-text">
                The provider will be unassigned from the licence.
              </div>
            </div>
          }
          isAlertConfirmation={true}
          confirmButtonName="Unassign"
          onCancel={() => {
            setUnassignLicenceKey(null);
          }}
          cancelButtonClassName={"cancel-button"}
          confirmButtonClassName="confirm-button"
        />
        {((isSubscriptionActive !== null && !isSubscriptionActive) ||
          (isBpSiteIdVerified !== null && !isBpSiteIdVerified)) && (
          <div className="grid-overlay">
            <div className="overlay-text">
              {isSubscriptionActive !== null && !isSubscriptionActive
                ? "Renew your subscription to assign licences."
                : isBpSiteIdVerified !== null &&
                  !isBpSiteIdVerified &&
                  "Verify BP Site ID to assign licences."}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
